<template>
    <div class="info-wrap">
        <!-- 触发标识 -->
        <div class="info-logo">
            <img src='~assets/image/information.svg'>
            <div class="dot" :class="{active:task_list.length!=0 || exam_list.length!=0}"></div>
        </div>

        <!-- 悬浮列表 -->
        <div class="fixed-box">
            <div class="fixed-main">
                <div class="tab-head">
                    <div v-show="task_flag" :class="{active:activeIndex == 0}" @click='changeIndex(0)'>任务消息</div>
                    <div v-show="exam_flag" :class="{active:activeIndex == 1}" @click='changeIndex(1)'>审核消息</div>
                </div>
                <div class="tab-wrap">
                    <z-scrollDiv v-show="task_flag && activeIndex == 0" :class="{active:task_list.length !== 0}">
                        <div class="info-item" v-for="(item,index) in task_list" :key="item.info_id">
                            <div class="message-box">
                                <div class="main">
                                    {{ item.message }}
                                </div>
                            </div>
                            <div class="confirm-btn" @click="readInfo(item.info_id,index)">知道了</div>
                        </div>
                        
                    </z-scrollDiv>
                    <z-scrollDiv v-show="exam_flag && activeIndex == 1" :class="{active:exam_list.length !== 0}">
                        <div class="info-item" v-for="(item,index) in exam_list" :key="item.info_id">
                            <div class="message-box">
                                <div class="main">
                                    {{ item.message }}
                                </div>
                            </div>
                            <div class="confirm-btn" @click="readInfo(item.info_id,index)">知道了</div>
                        </div>
                    </z-scrollDiv>
                </div>
                <div class="nothing"><img src="~assets/image/info-nothing.svg"></div>
            </div>

            <div class="front-btn green" @click="link">查看全部</div>
        </div>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex"

export default {
    data(){
        return {
            activeIndex:0,
            task_list:[],  //未读的任务信息
            exam_list:[],  //未读的审核信息

            alert_box:[],  //弹窗消息 实体
        }
    },
    computed:{
        ...mapState(['userInfo']),
        ...mapGetters(['codeList']),
        task_flag(){  //在正常BU
            return this.userInfo.bu.type == 0;
        },
        exam_flag(){ //拥有审核权限
            return this.codeList.some(code=> code == 1500);
        },
    },
    created(){
        // 如果在正常BU
        if(this.task_flag){
            this.$infoSystem.get("task",arr=>{
                this.task_list = this.mix_sort(arr);
            });

            this.$infoSystem.listen('task',arr=>{
                this.task_list = this.mix_sort(this.task_list,arr);
            })
        }
        // 如果拥有审核权限
        if(this.exam_flag){
            this.$infoSystem.get("examine",arr=>{
                this.exam_list = this.mix_sort(arr);
            });

            this.$infoSystem.listen('examine',arr=>{
                this.exam_list = this.mix_sort(this.exam_list,arr);;
            })
        }

        this.activeIndex = this.task_flag?0:1;

        // 弹窗提醒通知在这里
        this.$infoSystem.listen('alert',arr=>{
            arr.forEach((info,i) => {
                setTimeout(()=>{
                    let box = this.$notify({
                        title: '通知',
                        message:info.message,
                        duration:0,
                        onClose:()=>{
                            if(this.userInfo.id){
                                this.$func.hasRead(info.info_id);
                            }
                        },
                    });
                    this.alert_box.push(box);  
                },30)
            });
        })


        // 登出监听
        this.$infoSystem.logout(()=>{
            for(let box of this.alert_box){
                box.close();
            }
        });
        
    },

    methods:{
        changeIndex(index){  //改变序号
            this.activeIndex = index;
        },
        mix_sort(arr1,arr2 = []){  //混合数组并排序
            let arr = arr1.concat(arr2);
            return arr.sort((a,b)=>b.time-a.time);
        },
        readInfo(id,index){  //已读消息
            this.$func.hasRead(id,()=>{
                if(this.task_list[index] && this.task_list[index].info_id == id){
                    this.task_list.splice(index,1);
                }else if(this.exam_list[index] && this.exam_list[index].info_id == id){
                    this.exam_list.splice(index,1);
                }
            },err=>{
                console.log(err)
            })
        },
        link(){  //跳转
            this.$router.push({
                name:'infoHistory',
            })
        }
    },
}
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    @item_h:70px;
    @item_limit:4;
    @color:#4a6182;

    .info-wrap{
        height:@front_head_h;
        display: inline-block;
        margin-right: 20px;
        padding: 0 10px;
        &:hover{
            .fixed-box{
                height:425px;
                opacity: 1;
            }
        }
    }
    .info-logo{
        position: relative;
        top:50%;
        transform: translateY(-50%);
        cursor: pointer;
        .dot{
            height:8px;
            width:8px;
            background: #ff4f4f;
            border-radius: 50%;
            position: absolute;
            top:-2px;
            right:-3px;
            border: 2px solid #fff;
            transition:0.3s;
            opacity: 0;
            &.active{
                opacity: 1;
            }
        }

    }

    .fixed-box{
        position:fixed;
        overflow: hidden;
        opacity: 0;
        width:300px;
        height:0;
        top:@front_head_h;
        right:10px;
        background: #fff;
        color:#666;
        font-size: 12px;
        z-index: 100;
        transition: 0.3s;
        box-shadow: 0 0 6px 0 rgba(140, 140, 140, 0.5);
        text-align: center;

        // 信息主体包裹
        @tab_head:40px;
        @tab_wrap_padd:20px;
        .fixed-main{
            height:calc(~"@{tab_head} + @{item_limit}*@{item_h} + @{tab_wrap_padd}*2");
            position: relative;
            .nothing{
                position: absolute;
                top:calc(~"50% + @{tab_head}/2");
                left:50%;
                transform: translate(-50%,-50%);
                user-select: none;
                z-index:-1;
            }
        }

        // tab头部
        .tab-head{
            height:@tab_head;
            text-align: center;
            font-size: 12px;
            color:#858585;
            >div{
                display:inline-block;
                margin: 8px 5px 0;
                transition: 0.3s;
                padding-bottom: 10px;
                cursor: pointer;
                position: relative;
                &:after{
                    content:"";
                    position:absolute;
                    width:70%;
                    height:2px;
                    left:50%;
                    bottom:0;
                    transform: translateX(-50%);
                    background: @color;
                    opacity: 0;
                    transition: 0.3s;
                }

                &:hover{
                    color:@color;
                }
                &.active{
                    color:@color;
                    &:after{
                        opacity: 1;
                    }
                }
            }            
        }

        // 消息包裹
        .tab-wrap{
            padding: @tab_wrap_padd 0;
            >div.active{
                height:@item_limit*@item_h;
                background: #fff;
                // position: relative;
                // .nothing{
                //     position: absolute;
                //     top:50%;
                //     left:50%;
                //     transform: translate(-50%,-50%);
                //     user-select: none;
                // }
            }
            .info-item{
                // min-height:@item_h;
                font-size:12px;
                .clear();
                overflow: hidden;
                transition:0.3s;
                position: relative;
                &:after{
                    content:"";
                    width:calc(~"100% - 10px");
                    height:1px;
                    background:#e3e9f3;
                    position: absolute;
                    right:0;
                    bottom:0;
                }
                &:hover{
                    background: rgba(4, 180, 170,0.14);
                    background: rgba(111, 145, 194,0.19);
                }

                .message-box{
                    width:210px;
                    min-height:@item_h;
                    box-sizing: border-box;
                    padding: 10px 0 10px 30px;
                    position: relative;
                    float: left;
                    font-size: 0px;

                    display: flex;
                    justify-content: left;
                    align-items: center;
                    .main{
                        display: inline-block;
                        vertical-align: middle;
                        width:160px;
                        font-size: 12px;
                        word-break:break-all;
                        text-align: left;
                    }
                }
                .confirm-btn{
                    position: absolute;
                    right:20px;
                    top:50%;
                    transform: translateY(-50%);
                    height:30px;
                    line-height: 30px;
                    width:55px;
                    border-radius: 2px;
                    background:@color;
                    text-align: center;
                    cursor: pointer;
                    transition:0.3s;
                    color:#fff;
                    // &:hover{
                    //     background:#c6eeea;
                    // }
                    &:hover{
                        background:#5e7596;
                        border-color: #5e7596;
                    }
                    &:active{
                        background:#455c7c;
                        border-color: #455c7c;
                    }
                }
            }
        }

        // 大按钮
        .front-btn{
            width:250px;
            margin-top: 18px;
            font-size: 12px;
            background:@color;
            border-color: @color;
            &:hover{
                background:#5e7596;
                border-color: #5e7596;
            }
            &:active{
                background:#455c7c;
                border-color: #455c7c;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// read-info.vue?033d17a5